export default {
    banned: 'You do not have permission to view this room...',
    blocked: 'You are blocked from entering this room...',
    cancel: 'Cancel',
    clearAll: 'Clear All',
    deleteRooms: 'Delete Rooms',
    empty: {
        before: 'You currently have no Rooms open.',
        after: 'to visit a Chat Room!',
    },
    kicked: 'You have been kicked out of this room...',
    lounge: 'Lounge',
    memberRoom: 'Member room',
    noLoungeAccess: 'You do not have permission to access this lounge.',
    noTopicAvailable: 'No topic available...',
    shortTitle: 'Rooms',
    tipped: 'Tipped',
    tippedTitle: 'Tipped Models',
    tippedEmpty: {
        before: 'No tipped models found.',
        after: '',
    },
    tippedError: 'Unable to load tipped models. Please try again later.',
    tippedSubtitle: 'Models with whom you have spent at least 200 tokens',
    title: 'Recently Visited Rooms',
    viewableRoom: 'for a viewable room.',
}
